import React from 'react';

import Breadcrumb from '../../components/enfusion/Header/Breadcrumb';
import { getAbsoluteUrl } from '../../lib/helpers';

const NewsHeader = ({ title, link }) => {
    return (
        <>
            <div className="md:pt-36 pt-28">
                <div className="container">
                    <div className="flex items-center">
                        <i className="inline-block w-2.5 min-w-[0.66rem] h-2.5 mr-3 border-2 rounded-10 border-purple  "></i>
                        <span className="font-medium label">Media</span>
                    </div>
                    {title && (
                        <h1 className="mt-5 mb-6 lg:mb-10 md:mt-8 h1 wow fadeInUp">
                            {title}
                        </h1>
                    )}
                    {link && (
                        <div className="mb-14 lg:pr-5">
                            <a
                                href={getAbsoluteUrl(link?.url)}
                                target={link?.target}
                                className="flex items-center font-medium lead icon-circle hover:text-purple-midnight"
                            >
                                {link?.title}
                                <span className="relative h-4 ml-3">
                                    <i className="inline-block en-long-arrow text-32 leading-18 relative z-[1]"></i>

                                    <svg
                                        width="32"
                                        height="32"
                                        className="absolute -right-3 -top-2 icon-circle__circle"
                                    >
                                        <circle
                                            cx="16"
                                            cy="16"
                                            r="15"
                                            className="icon-circle__base"
                                        ></circle>
                                        <circle
                                            cx="16"
                                            cy="16"
                                            r="15"
                                            className="icon-circle__fill icon-circle__fill--dark"
                                        ></circle>
                                    </svg>
                                </span>
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default NewsHeader;
